import vmClient from 'app/services/vmClient';
import { Entity, EntityStringId, IEntityType, IEntity } from 'app/types/entity';
import { Language, LanguageMarshaller } from 'app/constants/enums/Language';
import { TranslationsForEntity, ALL_TRANSLATIONS } from 'app/constants/schemas/translations';

export interface ICurriculum extends IEntity {
  attributes: {
    id: EntityStringId;
    language: Language;
    isDefault: boolean;
  };
}

export type Curriculum = Entity<ICurriculum>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Curriculum: IEntityType<ICurriculum> = vmClient.defineClass({
  typeName: 'Curriculum',
  version: 2,
  persisted: true,
  attributes: {
    language: {
      type: Language,
      marshaller: LanguageMarshaller,
      notNull: true,
    },
    isDefault: {
      type: 'boolean',
      notNull: true,
      // Renaming the attribute because `default` is a js keyword.
      from: 'default',
    },
  },
});

export const CurriculumTranslations: Partial<TranslationsForEntity<ICurriculum>> = {
  language: {
    getLabel: (t) => t('entity-fields.Curriculum.language.label'),
  },
  isDefault: {
    getLabel: (t) => '',
    getInlineLabel: (t) => t('entity-fields.Curriculum.isDefault.inline-label'),
  },
};

ALL_TRANSLATIONS.set(Curriculum, CurriculumTranslations);
